import { CircularProgress } from "@mui/material";

const Loader = () => {
    return (
        <div className="loader">
            <div className="loading-dotss" style={{ marginRight: '20px' }}><p style={{ marginRight: '20px' }}>Loading</p><span> .</span><span>.</span><span>.</span></div>  <CircularProgress />
        </div>
    );
};

export default Loader;
